import React from "react";
import { Container, Row, Col, Image, Button } from "react-bootstrap";
import aluminum from "../Assets/Images/aluminum-laminated.jpg";
import braided1 from "../Assets/Image/braided-aluminium-1.jpg";
import { useNavigate } from "react-router-dom";
import { IoMdArrowRoundBack } from "react-icons/io";
import { Helmet } from "react-helmet";

const AluminumLaminatedFlexibles = () => {
  const navigate = useNavigate();
  return (
    <>
      <Helmet>
        <title>Aluminum Laminated Flexibles | Delta Engineering</title>
        <meta
          name="description"
          content="High-performance aluminium laminated flexible connectors for efficient power distribution. Customizable solutions for transformers, switchgear, control panels, bus ducts, and renewable energy systems."
        />
        <meta
          name="keywords"
          content="Aluminum Laminated Flexibles, Aluminium Laminated Flexible Connectors, Aluminium Shunts, Aluminium Jumpers, Busbar Connectors, Flexible Power Distribution Connectors, Electrical Connectors"
        />

        {/* Open Graph / Facebook */}
        <meta property="og:title" content="Aluminum Laminated Flexibles" />
        <meta
          property="og:description"
          content="Manufactured using high-purity aluminium foils, our laminated flexible connectors ensure superior conductivity, durability, and flexibility for industrial power applications."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://www.yourdomain.com/aluminum-laminated-flexibles"
        />
        <meta
          property="og:image"
          content="https://www.yourdomain.com/images/aluminum-laminated-flexibles.jpg"
        />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Aluminum Laminated Flexibles" />
        <meta
          name="twitter:description"
          content="Custom aluminium laminated flexible connectors designed for transformers, control panels, bus ducts, switchgear, and renewable energy distribution."
        />
        <meta
          name="twitter:image"
          content="https://www.yourdomain.com/images/aluminum-laminated-flexibles.jpg"
        />
      </Helmet>

      <section className="productbanner1 d-flex align-items-center position-relative">
        <div className="overlay-layer"></div>
        <Container className="text-center position-relative z-2">
<Row className="justify-content-center">
  <Col lg={8} className="hero-content text-center">
    <h2
      className="hero-title"
      data-aos="zoom-in"
      data-aos-delay="300"
    >
     <span className="blue-text">Aluminum Laminated </span>{" "}
  <span className="white-text">Flexibles</span>
    </h2>
    <p
      className="hero-subtitle"
      data-aos="zoom-in"
      data-aos-delay="200"
    >
      High-performance laminated connectors for flexible, efficient
                  power distribution
    </p>
  </Col>
</Row>
        </Container>
      </section>
      <section className="py-5 bg-light pt-3" style={{ position: "relative" }}>
        <Button onClick={() => navigate("/ourproducts")} className="back-btn">
          <IoMdArrowRoundBack className="back-icon" />
          Back
        </Button>
        <Container>
          <Row className="text-center mb-4">
            <Col>
              <h3 className="fw-bold text-center section-title">
                Aluminium Laminated Flexible Connectors
                <span className="title-underline"></span>
              </h3>
            </Col>
          </Row>

          <Row className="align-items-center mb-4">
            <Col md={4}>
              <Image
                src={aluminum}
                alt="Aluminium Laminated Flexible Connectors"
                fluid
                rounded
              />
            </Col>
            <Col md={8}>
              <p
                className="text-muted"
                style={{ lineHeight: "1.8", textAlign: "justify" }}
              >
                Aluminium Laminated Flexible Connectors are manufactured using
                high-purity aluminium foils, maintaining a constant
                cross-sectional area throughout their length. Typically
                solidified using the riveting method, these connectors can also
                be tin-plated upon request.
              </p>
              <p
                className="text-muted"
                style={{ lineHeight: "1.8", textAlign: "justify" }}
              >
                With equivalent cross-section, these connectors can carry the
                same current as solid bus bars, offering exceptional flexibility
                and connection performance. Fully customizable for current
                ratings, dimensions, and fitment constraints, we provide
                job-specific solutions tailored to projects.
              </p>
            </Col>
          </Row>

          <Row>
            <Col>
              <p
                className="text-muted"
                style={{ lineHeight: "1.8", textAlign: "justify" }}
              >
                Specialises in crafting aluminium laminated connectors, jumpers,
                and shunts tailored to custom bus-way sizing, fitment
                configurations, and electrical load capacities.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <section className="py-5">
        <Container>
          {/* <h2 className="fw-bold text-center section-title">Braided Aluminium Flexible Connectors</h2>
    <Row className="align-items-center mb-4">
  <Col md={8}>
    <p className="text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
      Braided Aluminium Flexible Connectors provide a low resistance flex connector between
      two rigid bus bar sections that have dynamic motion. These connectors are widely used
      in electrical distribution, switchgear, and automobile industries due to their excellent flexibility.
    </p>
    <p className="text-muted" style={{ lineHeight: '1.8', textAlign: 'justify' }}>
      With characteristics like expansion and contraction, our products include Aluminium Braided
      Connectors, Wires, Strips, Busbars, and Ropes pressed with aluminium connectors. We deliver
      high-quality solutions for industries requiring bulk, customized, and regular supply.
    </p>
  </Col>

  <Col md={4}>
    <Image src={braided1} alt="Braided Aluminium Connector" fluid rounded />
  </Col>
</Row> */}

          <Row className="mb-4">
            <Col>
              <h4 className="fw-bold text-decoration-underline">
                Applications
              </h4>
              <ul className="text-muted" style={{ lineHeight: "1.8" }}>
                <li>Control Panels</li>
                <li>Bus-Ways & Bus-Ducts</li>
                <li>Transformers</li>
                <li>Isolators</li>
                <li>Switchgears</li>
                <li>Oil and Vacuum Circuit Breakers</li>
                <li>Generators</li>
                <li>Renewable Energy Power Distribution Systems</li>
                <li>Numerous Other Industry Applications</li>
              </ul>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default AluminumLaminatedFlexibles;
